import { FC, PropsWithChildren } from 'react';

const TextButtom: FC<PropsWithChildren<{ 
  onClick?: () => unknown,
  type?: 'typical' | 'delete',
  underline?: boolean,
  desabled?: boolean,
}>> = ({
  onClick,
  type = 'typical',
  children,
  underline = false,
  desabled = false,
}) => (
  <div
    tabIndex={-1}
    role="button"
    onClick={() => !desabled && onClick && onClick()}
    className={`
      cursor-pointer
      ${{
        typical: "text-primary hover:text-primary_hover",
        delete: "text-red-400 hover:text-red-500",
      }[type]}
      ${underline
        ? 'underline underline-offset-4'
        : ''
      }
    `}
  >
    {children}
  </div>
);
export default TextButtom;
